// extracted by mini-css-extract-plugin
module.exports = {"container":"Root_container__3BoDO","mobile":"Root_mobile__4ojiM","desktop":"Root_desktop__rrEbs","offset":"Root_offset__1mm01"};